/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 14:23:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useEffect, useState } from 'react';
import { Edit, FormTab, TabbedForm, usePermissions, Title } from 'react-admin';
import { connect } from 'react-redux';
import OverviewTab from './Tabs/Overview';
import ProjectTab from './Tabs/Projects';
import SiteTab from './Tabs/Sites';
import SubscriptionTab from './Tabs/Subscriptions';
import { SaveDeleteToolbar } from 'Components';
import { isSuperAdmin, isSuperManager } from 'utils/roles';
import { isChecklistAllowed } from 'utils/capabilities';

const OrganisationEdit = props => {
  const {
    hasDelete,
    hasCreate,
    hasShow,
    hasList,
    hasEdit,
    className,
    formValues,
    currentTabFilters,
    dispatch,
    onSave,
    location,
    ...rest
  } = props;
  const { permissions } = usePermissions(); // because permissions are re-requested on create org, use the hook rather than passed down permissions which can be stale
  const title = formValues[props.id] && formValues[props.id].name;
  const { capabilities } =
    (formValues[props.id] &&
      formValues[props.id].subscription &&
      formValues[props.id].subscription.subscriptionTier) ||
    {};
  const superAdmin = isSuperAdmin(permissions);
  const superManager = isSuperManager(permissions, props.id);
  const [showToolbar, setShowToolbar] = useState(false);

  const isOverviewTab = currentLocation => {
    const tabNumber =
      currentLocation.split('/').length === 4
        ? currentLocation.split('/')[3]
        : '';
    if (tabNumber === '') {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const checkUserPermissionsLocation = (location, permissions) => {
      if (location) {
        const currentLocation = location.pathname;
        if (
          isSuperManager(permissions, props.id) &&
          isOverviewTab(currentLocation)
        ) {
          return setShowToolbar(true);
        }
      }
      return setShowToolbar(false);
    };
    return checkUserPermissionsLocation(location, permissions);
  }, [location, permissions, props.id]);

  return (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <Edit title={title} {...rest}>
        <TabbedForm
          redirect={false}
          toolbar={
            showToolbar ? (
              <SaveDeleteToolbar hideDelete={!(permissions && superManager)} />
            ) : null
          }
        >
          <FormTab label={'resources.Organisation.fields.tab1'}>
            <OverviewTab
              allowChecklist={superAdmin || isChecklistAllowed(capabilities)}
              {...props}
            />
          </FormTab>
          <FormTab label={'resources.Organisation.fields.tab2'}>
            <ProjectTab {...props} />
          </FormTab>
          <FormTab label={'resources.Organisation.fields.tab3'}>
            <SiteTab {...props} />
          </FormTab>
          {superManager ? (
            <FormTab label={'resources.Organisation.fields.tab8'}>
              <SubscriptionTab {...props} />
            </FormTab>
          ) : null}
        </TabbedForm>
      </Edit>
    </>
  );
};

const mapStateToProps = state => {
  const { organisationTabsFilters } = state;
  return {
    formValues:
      state.admin.resources.Organisation &&
      state.admin.resources.Organisation.data,
    currentTabFilters: organisationTabsFilters,
  };
};

export default connect(mapStateToProps)(OrganisationEdit);
